<template>
    <div class="field">
        <div class="control has-icons-left">
            <label class="checkbox"><input v-model="is_usd" type="checkbox"> Is usd?</label>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            is_usd: {
                get: function () {
                    return this.$store.getters.getNewCarUSD
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarUsd', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorUsd
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/IsUsd.vue